/* eslint-disable @typescript-eslint/no-explicit-any */

export const applyKHop = ( cy: any, k: number, setKHop: (v: number) => void, toast: any) => {
  if (!cy) return;
  if (k <= 0) { clearKHop(cy, setKHop); return; }

  const sel = cy.nodes(':selected');
  if (sel.length === 0) {
    toast.info('Bitte zuerst mindestens einen Knoten auswählen');
    return;
  }

  let sub: any = sel;
  for (let i = 0; i < k; i++) sub = sub.closedNeighborhood();

  cy.batch(() => {
    cy.elements().removeClass('hidden-by-khop').style('display', 'element');
    const hide = cy.elements().not(sub);
    hide.addClass('hidden-by-khop').style('display', 'none');
  });
  setKHop(k);
  cy.fit(sub, 20);
};

export const clearKHop = (cy: any, setKHop: (v: number) => void) => {
  if (!cy) return;
  cy.batch(() => {
    cy.elements().removeClass('hidden-by-khop').style('display', 'element');
  });
  setKHop(0);
};
